import { createSelector } from 'reselect';

const selectSkillDetailModalState = state => state.SkillDetailModal;

export const selectFetching = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.fetching
);

export const selectError = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.error
);

export const selectSkillId = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.skillId
);

export const selectName = createSelector(selectSkillDetailModalState, (state, props) => state.name);

export const selectBestValidatedLevel = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.bestValidatedLevel
);

export const selectCurrentLevel = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.currentLevel
);

export const selectCategory = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.category
);

export const selectClaimLevel = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.claimLevel
);

export const selectChatbotLevel = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.chatbotLevel
);

export const selectClaimStatus = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.claimStatus
);

export const selectChatbotStatus = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.chatbotStatus
);

export const selectLatestClaimTimestamp = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.latestClaimTimestamp
);

export const selectLatestChatbotTimestamp = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.latestChatbotTimestamp
);

export const selectIsHighlighted = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.isHighlighted
);

export const selectValidations = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.validations
);

export const selectBeginnerCount = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.beginnerCount
);

export const selectIntermediateCount = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.intermediateCount
);

export const selectExpertCount = createSelector(
  selectSkillDetailModalState,
  (state, props) => state.expertCount
);
